import { useState, type FormEvent } from "react";
import { Navigate } from "react-router-dom";

import { Button, Field, TextInput } from "../components/ui";
import { ApiError, api } from "../lib/api";
import { useStore } from "../lib/store";

/**
 * Operator login. Single admin password. No username.
 */
export function Login() {
  const { state, toast } = useStore();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (state.boot === "ready" && !state.setup) return <Navigate to="/setup" replace />;
  if (state.boot === "ready" && state.authenticated) return <Navigate to="/" replace />;

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    if (!password) {
      toast("Password is required", "error");
      return;
    }
    setBusy(true);
    try {
      await api.login(password);
      window.location.assign("/");
    } catch (err) {
      const detail = err instanceof ApiError ? err.detail : "Login failed";
      toast(detail, "error");
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-full items-center justify-center px-6">
      <form
        onSubmit={(event) => void onSubmit(event)}
        className="w-full max-w-sm rounded-2xl border border-border bg-navy p-8"
      >
        <div className="mb-1 flex items-center gap-2">
          <span className="flex gap-1" aria-hidden>
            <span className="h-2 w-2 rounded-full bg-[#ff5f56]" />
            <span className="h-2 w-2 rounded-full bg-[#ffbd2e]" />
            <span className="h-2 w-2 rounded-full bg-[#27c93f]" />
          </span>
          <span className="font-mono text-[11px] tracking-[0.18em] text-teal">cdialer@ops — login</span>
        </div>
        <h1 className="mb-6 text-2xl font-medium tracking-tight">Operator console</h1>
        <Field label="password" prompt>
          <TextInput
            type="password"
            autoFocus
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </Field>
        <Button type="submit" variant="primary" className="mt-6 w-full" disabled={busy}>
          Sign in
        </Button>
      </form>
    </div>
  );
}
